import React from 'react';
import {useSelector} from 'react-redux';

import {COLUMNS} from '../../constants';
import {useGetAccountSearchResultDisabledUsers} from '../../hooks/useGetAccountSearchResultDisabledUsers';
import {accountSearchResultResultSelector} from '../../slices/account-search-result.slice';

import {HeaderCaption} from './header-caption';
import {HeaderSkeleton} from './header-skeleton';


type Props = {
    accountIds: number[],
    totalCount: number,
};

const DisabledUsersHeaderController = ({accountIds, totalCount}: Props) => {
    const {isLoading, loadingError} = useGetAccountSearchResultDisabledUsers({accountIds, totalCount});

    return (
        <HeaderCaption
            isLoading={isLoading}
            loadingError={loadingError}
            columnId={COLUMNS.DISABLED_NEWSLETTER_USERS}
        />
    );
};

export const DisabledUsersHeader = () => {
    const result = useSelector(accountSearchResultResultSelector);

    return result ? (
        <DisabledUsersHeaderController
            accountIds={result.data.map(({accountId}) => accountId)}
            totalCount={result.totalCount}
        />
    ) : (
        <HeaderSkeleton columnId={COLUMNS.DISABLED_NEWSLETTER_USERS}/>
    );
};
